//ver 1.2 GT ga360

(function () {
    if (
        !document.getElementsByClassName('__js_section').length ||
        document.location.href.indexOf('.html') > 0
    )
        return;

    var $sections = $('.__js_section'),
        initSlug =
            document.location.pathname.split('/').pop() ||
            $($sections).eq(0).attr('id');

    window.activeSlug = initSlug;

    var customOffset = $('.header').height() + 10,
        animationTime = 1000;

    $(window).on('resize', function () {
        customOffset = $('.header').height() + 10;
    });

    var initActiveSlugIndex =
        $('.article-wrapper[data-id=' + initSlug + ']').index() + 1;

    $('.art-slug-num').text(initActiveSlugIndex);
    // Przewijanie do sekcji slug jeżeli w URL jest ustawiony jakiś slug na starcie

    var scrollOnStart = function () {
            $('html,body').animate(
                {
                    scrollTop: $('#' + initSlug).offset().top - customOffset + 10,
                },
                animationTime,
                'easeOutExpo'
            );

            sendStats('progress', 'start', initSlug);

            changeActiveSlug(initSlug);
            initNavigation();
        },
        // staty pageviews i scrollboost pwp ----- {

        reportSlugTS = -1,
        reportSlug = function () {
            if (!statBase || !statBase.page || !statBase.site) {
                console.warn('_statsAnchors.js: basicStatData bez page/site - pomijam pageview');
                return;
            }
            if (!statData[activeSlug]) {
                console.warn('_statsAnchors.js: brak statData dla slug ' + activeSlug + ' - pomijam pageview');
                return;
            }

            if (lastReportedSlug === null) {
                //wyślij statystykę pageview standard

                wp_dot_addparams.ctags = statData[activeSlug].tags;
                custom360Action({
                    event: 'pageview',
                    page: {
                        pageviewType: 'standard',
                        error404: statBase.page.error404,
                        templateType: 'AS',
                    },
                    site: {
                        name: statBase.site.name,
                        version: statBase.site.version,
                        cms: statBase.site.cms,
                        as: {orderId: asorderid, productName: asproduct, name: asname},
                    },
                    content: {
                        title: statData[activeSlug].title,
                        category: {
                            IAB: statData[activeSlug].category.IAB,
                            Gemius: statData[activeSlug].category.Gemius,
                        },
                        tags: statData[activeSlug].tags,
                    },
                });
            } else {
                // wyślij statystykę pageview scrolboost vpv. pageviewType ma wartość "overlay"
                // gdy nie mamy doładowania i "scrollboost" gdy następuje doładowanie, ALE dla pseudo dynamicznych stron AS ma byc jednak scrollboost ;) - ustalone z Salestube !

                window.wp_content_selector = document.getElementById(lastReportedSlug);

                WP.stat.show(
                    wp_sn,
                    {
                        category: 'pageviewVpv',
                        label: 'scrollboost',
                        asproduct: asproduct,
                        asorderid: asorderid,
                        asname: asname,
                    },
                    'pageviewVpv'
                );
                //sendStats('pageviewVpv', 'scrollboost', activeSlug); // musi isć dot ptrzed ustawieniem wp_content_selector

                unloadData(lastReportedSlug);
                wp_dot_addparams.ctags = statData[activeSlug].tags;
                custom360Action({
                    event: 'pageviewVpv',
                    page: {
                        pageviewType: 'scrollboost',
                        error404: statBase.page.error404,
                        templateType: 'AS',
                    },
                    site: {
                        name: statBase.site.name,
                        version: statBase.site.version,
                        cms: statBase.site.cms,
                        as: {orderId: asorderid, productName: asproduct, name: asname},
                        frontendPlatform: 'other',
                    },
                    content: {
                        title: statData[activeSlug].title,
                        category: {
                            IAB: statData[activeSlug].category.IAB,
                            Gemius: statData[activeSlug].category.Gemius,
                        },
                        tags: statData[activeSlug].tags,
                    },
                    //"content": statData[activeSlug]
                });
            }

            window.lastReportedSlug = activeSlug;
            reportSlugTS = -1;
        },
        // ----- }

        changeActiveSlug = function (slug) {
            window.activeSlug = slug;

            if (getActiveSlugIndex() == 0) {
                //slug = "/";
                $('.header--nav ul').attr('class', 'order_' + 1); // == 0;
            }

            $('.header--nav [data-slug]').removeClass('__active');
            $('.header--nav [data-slug=' + activeSlug + ']').addClass('__active');
            $('.header--nav ul').attr('class', 'order_' + (getActiveSlugIndex() + 1));

            $('.art-slug-num').text((getActiveSlugIndex() + 1));

            if (document.location.search.length > 0) {
                history.pushState(
                    {
                        id: slug,
                    },
                    $(this).attr('title'),
                    slug + document.location.search
                );
                if (document.querySelector('title')) {
                    document.querySelector('title').innerText =
                        statData[activeSlug].title + '- ' + defaultSiteTitle;
                }
                if (document.querySelector('meta[property="og:title"]')) {
                    document.querySelector('meta[property="og:title"]').content =
                        statData[activeSlug].title + '- ' + defaultSiteTitle;
                }
                if (document.querySelector('meta[name="twitter:title"]')) {
                    document.querySelector('meta[name="twitter:title"]').content =
                        statData[activeSlug].title + '- ' + defaultSiteTitle;
                }
            } else {
                history.pushState(
                    {
                        id: slug,
                    },
                    $(this).attr('title'),
                    slug
                );
                if (document.querySelector('title')) {
                    document.querySelector('title').innerText =
                        statData[activeSlug].title + '- ' + defaultSiteTitle;
                }
                if (document.querySelector('meta[property="og:title"]')) {
                    document.querySelector('meta[property="og:title"]').content =
                        statData[activeSlug].title + '- ' + defaultSiteTitle;
                }
                if (document.querySelector('meta[name="twitter:title"]')) {
                    document.querySelector('meta[name="twitter:title"]').content =
                        statData[activeSlug].title + '- ' + defaultSiteTitle;
                }
            }

            if (lastReportedSlug === null) {
                // jeżeli pierwsze wejście to wysyłaj pageview od razu
                reportSlug();
            } else if (lastReportedSlug != slug) {
                // jeżeli zmiana sluga to wysyłaj po sekundzie statystykę

                if (reportSlugTS > -1) clearTimeout(reportSlugTS);
                reportSlugTS = setTimeout(reportSlug, 1000);
            } else {
                if (reportSlugTS > -1) clearTimeout(reportSlugTS);
            }
        },
        // Sprawdzanie numeru sluga, domyślnie aktualnego
        getActiveSlugIndex = function (slug) {
            if (!slug) slug = activeSlug;
            return $('.header--nav [data-slug=' + slug + ']')
                .parent()
                .parent()
                .index();
        },
        // Sprawdzanie czy user zescrollował do sekcji. Jeżeli tak to ustawia pozycję w nawigacji
        sectionScrollCheck = function () {
            sectionScrollCheckTS = setTimeout(sectionScrollCheck, 200);

            var $W = $(window),
                topScroll = $W.scrollTop(),
                wHeight = $W.height();

            if (topScroll > $('.header').height()) {
                $('.header').addClass('header--bg');
            } else {
                $('.header').removeClass('header--bg');
            }

            if ($('.section-head--full-image').height() + 200 < topScroll) {
                $('.left-nav').addClass('left-nav-visible');
            } else {
                $('.left-nav').removeClass('left-nav-visible');
            }

            // wymuszenie strony głównej
            if (
                topScroll <= customOffset &&
                document.location.pathname.split('/').pop().length < 1
            ) {
                changeActiveSlug($sections.eq(0).attr('id'));
                return;
            }

            for (var i = 0; i < $sections.length; i++) {
                var $section = $sections.eq(i),
                    sectionOffset = $section.offset().top,
                    sectionHeight = $section.height();

                if (
                    activeSlug != $section.attr('id') &&
                    topScroll > sectionOffset - customOffset - 10 &&
                    topScroll < sectionOffset + sectionHeight - customOffset
                ) {
                    changeActiveSlug($section.attr('id'));

                    break;
                }
            }
        },
        sectionScrollCheckTS = null,
        // Inicjalizacja metod dla obsługi nawigacji - clików i sprawdzanie scrolla, dodanie flagi podczas skrolowania
        initNavigation = function () {
            sectionScrollCheckTS = setTimeout(sectionScrollCheck, animationTime + 25);

            $('.header--nav [data-slug]').on('click', function (e) {
                window.isScrolling = true;
                // console.log('slug: ' + slug + ', activeSlug: ' + activeSlug + ', lastReportedSlug: ' + lastReportedSlug);
                if (sectionScrollCheckTS) clearTimeout(sectionScrollCheckTS);

                e.preventDefault();
                var $this = $(this),
                    slug = $(this).data('slug');
                if (!slug.length) slug = '/';

                changeActiveSlug(slug);

                $('html,body').animate(
                    {
                        scrollTop:
                            getActiveSlugIndex() > 0
                                ? $('#' + slug).offset().top - customOffset + 10
                                : 0,
                    },
                    animationTime,
                    'easeInOutExpo',
                    function () {
                        window.isScrolling = false;
                    }
                );
                sectionScrollCheckTS = setTimeout(
                    sectionScrollCheck,
                    animationTime + 25
                );
                // przewinięcie głównego zdjęcia po autoscrollu z nawigacji
                // $('html,body').delay(370).animate({scrollTop: $('#' + slug).find('h1').offset().top - 120 }, 820, 'easeInOutExpo')
            });

            $('.art-arrow').on('click', function (e) {
                if (
                    ($(this).hasClass('art-arrow-prev') && getActiveSlugIndex() == 0) ||
                    ($(this).hasClass('art-arrow-next') &&
                        getActiveSlugIndex() == $('.article-wrapper').length - 1)
                ) {
                    return;
                }

                window.isScrolling = true;
                // console.log('slug: ' + slug + ', activeSlug: ' + activeSlug + ', lastReportedSlug: ' + lastReportedSlug);
                if (sectionScrollCheckTS) clearTimeout(sectionScrollCheckTS);

                e.preventDefault();
                var slug;
                if ($(this).hasClass('art-arrow-prev')) {
                    slug = $('.article-wrapper')
                        .eq(getActiveSlugIndex() - 1)
                        .attr('data-id');
                } else {
                    slug = $('.article-wrapper')
                        .eq(getActiveSlugIndex() + 1)
                        .attr('data-id');
                }

                changeActiveSlug(slug);

                $('html,body').animate(
                    {
                        scrollTop:
                            getActiveSlugIndex() > 0
                                ? $('#' + slug).offset().top - customOffset + 10
                                : 0,
                    },
                    animationTime,
                    'easeInOutExpo',
                    function () {
                        window.isScrolling = false;
                    }
                );
                sectionScrollCheckTS = setTimeout(
                    sectionScrollCheck,
                    animationTime + 25
                );

                // console.log($('.article-wrapper').eq(3).attr('data-id'))
                sendStats('art-arrow', 'click_left-nav', 'nawigacja', slug);

                if (!isScrolligFlag) {
                    custom360Action({
                        "event": "site_interaction",
                        "eventCategory": "button_navigation",
                        "eventAction": deviceTouch ? "tap" : "click",
                        "eventLabel": slug
                    });

                }

            });
        };

    if (initSlug.length > 1) {
        setTimeout(scrollOnStart, 800);
    }
})();
